import React from 'react';
import { useIsMobile } from '@/core/hooks/useMediaQuery';
import { formatPrice } from '@/shared/utils/priceFormatter';
import type { OrderItem } from '../../domain/models/postOrderAddress.types';

interface OrderSummaryProps {
  items: OrderItem[];
}

export const OrderSummary: React.FC<OrderSummaryProps> = ({ items }) => {
  const isMobile = useIsMobile();

  return (
    <div className="border rounded-md bg-white p-4 mb-6">
      <p className={`text-xl ${isMobile ? 'mb-4' : 'mb-6'}`}>
        {isMobile ? 'Add your delivery details' : 'Add your details now to get it delivered to your doorstep!'}
      </p>

      <div className="flex flex-col gap-6 max-h-60 overflow-y-auto">
        {items.map(item => (
          <div key={item.orderItemCode} className="flex gap-4">
            <img
              src={item.imageUrl}
              alt={item.productName}
              className="w-16 h-16 shrink-0 rounded border object-cover bg-[#f0f0f0]"
            />

            <div className="flex-1 min-w-0">
              <div className="flex items-start gap-2">
                <div className="flex-1 min-w-0">
                  <h4 className="truncate text-sm font-medium text-gray-900">
                    {item.productName}
                  </h4>

                  <p className="mt-0.5 text-xs text-gray-500">
                    Code: {item.orderItemCode}
                  </p>
                </div>

                <span className="shrink-0 text-sm font-semibold text-gray-900">
                  {formatPrice(item.sellingPrice)}
                </span>
              </div>

              <p className="mt-1 text-xs font-medium text-gray-500">
                {!isMobile && 'Delivery by:'} {item.expectedDeliveryDate}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};